import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { ProductListComponentWUT } from '../../../ui/product-list';
export const ProductListWUT = (props)=>{
    const { fieldType = FIELD_TYPES.PRODUCT_LIST } = props;
    return /*#__PURE__*/ React.createElement(ProductListComponentWUT, {
        ...props,
        fieldType: fieldType
    });
};

//# sourceMappingURL=product-list-wut.js.map